module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pNLPC4/tc-custom/9781647502935.jpg?1705688281677",
      "alt": "This image is the cover for the book Timmy the Toad"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Timmy the Toad\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "8.0pt",
      "margin-left": "0mm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Timmy takes pride in being different and represents that we should love and always treat others equally. The author speaks to the children in their language, asking them to trust their teachers and counsellors, to never be afraid to speak up about abuse if it is happening in the home. The book is a part of the rescue mission of restoring the lives of children. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tyler Harrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0mm",
      "font-size": "15px",
      "font-family": "\"Arial\",sans-serif",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "13px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("The author was 12 years old when he identified with poetry. He always had these poetic thoughts in his head from English class with Mrs. Rakestraw in 6th grade. He had a hard life and God rewarded him by getting his work published. He finally got to share his thoughts and love with others. His message is, “Choose love today, not hate.”")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0